import type { BlockWarning } from "@/api/manual/rules";

export function TerminologyWarnings({ warnings }: { warnings: BlockWarning[] }) {
	if (warnings.length === 0) {
		return null;
	}

	return (
		<div className="rounded-md border border-warning/40 bg-warning/5 p-3 text-sm">
			<p className="font-medium text-foreground">Avisos de terminologia ({warnings.length})</p>

			<ul className="mt-1 list-disc pl-5 text-muted-foreground">
				{warnings.map((warning) => (
					<li key={`${warning.blockId}-${warning.term}`}>
						<span className="font-medium text-foreground">{warning.term}</span>
						<span className="block text-xs">{warning.suggestion}</span>
					</li>
				))}
			</ul>
		</div>
	);
}
